/*************************************************/
/* SELECTOR WIDTH                                */
/*************************************************/

export function selectorWidth() {
    const items = document.querySelectorAll('.language-selector__list')

    let maxWidth = 0;
    items.forEach(item => {
        maxWidth = Math.max(maxWidth, item.scrollWidth);
    });

    document.querySelector('.language-selector').style.setProperty(
        '--language-selector-width',
        `${maxWidth}px`
    );

    init();
}